module.exports = __webpack_public_path__ + "a85bc9e7dbb8b9c2cb9497369eedea14.png";